import _ from 'underscore';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';

const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/hotel-center');

export function feedErrorMapper(errorCode) {
  if (_.isEmpty(errorCode)) {
    return '';
  }

  return i18n.getString(`HotelCenter_Feed_Error_${errorCode}`) ||
    i18n.getString('HotelCenter_Feed_Error_OtherError');
}
